import React from 'react'
import './app.css';
import HomeScreen from './screens/HomeScreen';
import Header from './assets/images/Vematic-Header.png'




function App() {


  return (
    <>
      <img src={Header} alt='Vematic-header' width='100%' className='header' />
      <HomeScreen />
    </>
  );
}

export default App;
